import React, { useState, useEffect } from 'react'
import { DialogContent, Dialog } from '@mui/material'
import styled from 'styled-components'
import theme from 'styles/theme'
import useProgramDoneDialog from 'activity/hooks/useProgramDoneDialog'

export default function ReadinessDialog({ open }) {
  const {
    saveRatingAsReadiness,
    rating,
    setRating
  } = useProgramDoneDialog()

  const [openDialog, setOpenDialog] = useState(false)

  function closeDialog() {
    setOpenDialog(false)
  }

  useEffect(() => {
    if (open) {
      setOpenDialog(true)
    }
  }, [open])

  const ratingButtonClassName = (index) => {
    if (rating) {
      if (index > rating) {
        return 'notHighlighted'
      }
      return 'highlighted'
    }
    return `circle${10 - index}`
  }

  return (
    <Dialog.Stylesheet
      fullScreen
      open={openDialog}
      disableEnforceFocus
    >
      <ReadinessDialog.Content>
        <div className="header">
          <h2>Lets Get Started!</h2>
        </div>

        <div className="rating">
          <h3>On a scale of 1 to 10—where 1 is completely exhausted and not prepared for stressful work and 10 is fresh
            and ready to set a personal record—where do you rank how you feel?</h3>
          <div className="ratingCircles">
            {[10, 9, 8, 7, 6, 5, 4, 3, 2, 1].map((score, idx) => (
              <button
                key={`${score}-${String(idx)}`}
                type="button"
                className={ratingButtonClassName(10 - idx)}
                onClick={() => setRating(score)}
              >
                {score}
              </button>
            ))}
          </div>
          <div className="labels">
            <span>bad</span>
            <span>great</span>
          </div>
        </div>

        <button
          type="button"
          className={rating ? 'doneBtn' : 'doneBtnDisabled'}
          disabled={!rating}
          onClick={() => {saveRatingAsReadiness(); closeDialog()}}
        >
          Done
        </button>

        <button
          type="button"
          className='skipBtn'
          onClick={closeDialog}
        >
          Skip
        </button>
      </ReadinessDialog.Content>
    </Dialog.Stylesheet>
  )
}

Dialog.Stylesheet = styled(Dialog)``

ReadinessDialog.Content = styled(DialogContent)`
  padding: 3rem !important;
  max-width: 30rem;
  margin: 0 auto;
  .header {
    margin-top: 5rem;
    h2 {
      font-weight: 500;
      font-size: 2rem;
    }
    p {
      font-weight: 600;
      color: #595959;
    }
    .info {
    margin-top: 2rem;
      display: flex;
      justify-content: center;
      p {
        font-weight: 700;
        font-size: 0.75rem;
        color: #595959;
        margin: 0;
      }
      h3 {
        font-weight: 500;
        font-size: 1.25rem;
        color: #000;
      }
    }
  }
  .rating {
    margin-top: 4rem;
    h3 {
      text-align: center;
      color: ${theme.palette.secondary.g800};
      font-size: 1.25rem;
      font-weight: 500;
      line-height: 1.6em;
    }
    .ratingCircles {
      display: flex;
      flex-direction: row-reverse;
      justify-content: space-evenly;
      margin-top: 4rem;
      button {
        border-radius: 18.868125rem;
        width: 2rem;
        height: 1.9625rem;
        text-align center;
        cursor: pointer;
        font-weight: 600;
        font-size: 0.75rem;
        background-color: #fff;
      }
      button:hover {
        background-color: ${theme.palette.secondary.g800};
        opacity: 0.4;
        color: #fff;
        border: 0;
        box-shadow: 0 0 1rem 0.2rem ${theme.palette.secondary.g800};
      }
      button:hover ~ button {
        background-color: ${theme.palette.secondary.g800};
        color: #fff;
        border: 0;
      }
      .circle10 {
        border: 2px solid #a4161a;
        color: #a4161a;
      }
      .circle9 {
        border: 2px solid #a4161a;
        color: #a4161a;
      }
      .circle8 {
        border: 2px solid #F4861E;
        color: #F4861E;
      }
      .circle7 {
        border: 2px solid #F4861E;
        color: #F4861E;
      }
      .circle6 {
        border: 2px solid #D1A603;
        color: #D1A603;
      }
      .circle5 {
        border: 2px solid #D1A603;
        color: #D1A603;
      }
      .circle4 {
        border: 2px solid #198F96;
        color: #198F96;
      }
      .circle3 {
        border: 2px solid #198F96;
        color: #198F96;
      }
      .circle2 {
        border: 2px solid #09555D;
        color: #09555D;
      }
      .circle1 {
        border: 2px solid #09555D;
        color: #09555D;
      }
      .highlighted {
          background-color: ${theme.palette.secondary.g800};
          color: #fff;
          border: 2px solid ${theme.palette.secondary.g800};
      }
      .notHighlighted {
         border: 2px solid ${theme.palette.secondary.g800};
         color: ${theme.palette.secondary.g800};
      }
    }
    .labels {
        color: #09555D;
        padding: 1rem 1.5rem 1rem 1.5rem;
        display: flex;
        justify-content: space-between;
        span {
          font-weight: 500;
        }
    }
  }
  .doneBtn {
    margin-top: 3rem;
    border: 0;
    width: 100%;
    padding: 1rem;
    background-color: ${theme.palette.secondary.g800};
    color: #fff;
    border-radius: 0.625rem;
    font-weight: 700;
  }
  .doneBtnDisabled {
    margin-top: 3rem;
    border: 0;
    width: 100%;
    padding: 1rem;
    background-color: #F8F8F8;
    color: gray;
    border-radius: 0.625rem;
    font-weight: 700;
  }

  .skipBtn {
    margin-top: 3rem;
    border: 0;
    width: 100%;
    padding: 1rem;
    background-color: lightgray;
    color: #fff;
    border-radius: 0.625rem;
    font-weight: 700;
  }
`

